import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Actions, Select, Store, ofActionDispatched } from '@ngxs/store';
import { ExtendedAttributeFilterInterface } from 'app/library/all-users/interfaces/extended-attribute-filer.interface';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize, take } from 'rxjs/operators';
import { Module } from '../../../module/models/module.model';
import { FetchAllExecutions, FetchAllExecutionsSuccess } from '../../actions';
import { AllModulesState } from '../../models/all-modules.state';

export class AllExecutionsDataSource implements DataSource<Module> {
    @Select(AllModulesState.getFiltersList)
    filter$: Observable<Module>;

    private _loadingSubject = new BehaviorSubject<boolean>(false);

    public loading$ = this._loadingSubject.asObservable();

    constructor(private _filteredModule$: Observable<Module[]>, private _store: Store, private _action$: Actions) {}

    connect(collectionViewer: CollectionViewer): Observable<Module[]> {
        return this._filteredModule$;
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this._loadingSubject.complete();
    }

    loadModules(
        search?: string,
        pageSize?: number,
        pageNumber?: number,
        sortBy?: string,
        sortOrder?: string,
        statusesIds?: string[],
        tags?: string[],
        types?: string[],
        extendedAttributesFilters?: ExtendedAttributeFilterInterface[],
        executionDate?: ExtendedAttributeFilterInterface,
        columns?: string[]
    ): void {
        this._loadingSubject.next(true);

        this._store.dispatch(
            new FetchAllExecutions({
                search,
                pageSize,
                pageNumber,
                sortBy,
                sortOrder,
                statusesIds,
                tags,
                types,
                extendedAttributesFilters,
                executionDate,
                columns,
            })
        );

        this._action$
            .pipe(
                ofActionDispatched(FetchAllExecutionsSuccess),
                finalize(() => this._loadingSubject.next(false)),
                take(1)
            )
            .subscribe();
    }
}
